import React from 'react';
import { Facebook, Twitter, Linkedin, Mail, MapPin, Phone, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-20 pb-10 px-6 md:px-12 border-t border-white/5">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="Sooners Land Logo" className="logo h-12 w-12 bg-white p-1 rounded-xl" />
              <div className="flex flex-col">
                <span className="text-xl font-extrabold tracking-tight">SOONERS LAND</span>
                <span className="text-[10px] font-bold text-accent tracking-[0.2em] uppercase">Engineering Excellence</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              Sooners Land, LLC provides elite project management and engineering services for global infrastructure and building projects.
            </p>
            <div className="flex gap-4">
              {[Facebook, Twitter, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent hover:text-white transition-all duration-300">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white border-b border-accent w-fit pb-1">Quick Links</h3>
            <ul className="space-y-4 text-slate-400 text-sm font-medium">
              {[
                { name: "Home", path: "/" },
                { name: "Projects", path: "/projects" },
                { name: "About Us", path: "/about" },
                { name: "Contact", path: "/contact" },
                { name: "Clients", path: "/clients" },
                { name: "Certificates", path: "/experience" }
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="hover:text-accent transition-colors flex items-center gap-2 group">
                    <span className="w-0 h-0.5 bg-accent transition-all duration-300 group-hover:w-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h3 className="text-lg font-bold mb-6 text-white border-b border-accent w-fit pb-1">Get In Touch</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-slate-400 text-sm">
              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-accent shrink-0" />
                  <p>2025 SOUTH NICKLAS AVE., SUITE 115<br />OKLAHOMA CITY, OK 73128</p>
                </div>
                <div className="flex items-center gap-3">
                  <Mail size={20} className="text-accent shrink-0" />
                  <a href="mailto:Sooners.P.M.Co@Gmail.com" className="hover:text-accent transition-colors">Sooners.P.M.Co@Gmail.com</a>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <Globe size={18} className="text-accent shrink-0" />
                  <span>USA: +1 281 626 3263</span>
                </div>
                <div className="flex items-center gap-3">
                  <Globe size={18} className="text-accent shrink-0" />
                  <span>Turkey: +90 531 273 7922</span>
                </div>
                <div className="flex items-center gap-3">
                  <Globe size={18} className="text-accent shrink-0" />
                  <span>Saudi Arabia: +966 567 5599 63</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-500 text-[10px] uppercase tracking-widest font-bold">
          <p>&copy; 2026 SOONERS LAND, LLC. All rights reserved.</p>
          <div className="flex gap-8">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;